import { Tooltip } from 'primereact/tooltip';
export const alphabeticStringValidation = (val) => {
    const regex = /^[a-zA-z]+([\s][a-zA-Z]+)*$/;
    return regex.test(val);
};

export const spaceNotAllowed = (val) => {
    const regex = /^(?!.*\s).+$/;
    return regex.test(val);
};


export const regularString = (val) => {
    let trimed = val
    if (typeof val !== 'object' && isNaN(val)) {
        trimed = val?.trim() || val
    }
    const regex =
        /^[\w!@#$%^&*()\-=_+{}[\]|;:'",.<>/?öäüÖÄÜß]+(?: [\w!@#$%^&*()\-=_+{}[\]|;:'",.<>/?öäüÖÄÜß]+)*$/;
    return regex.test(trimed);
};

export const stringSpace = (val) => {
    if(val){
        const regex = /^(?=.*[a-zA-Z])[a-zA-Z ]*$/
        return regex.test(val)
    }else{
        return true
    }
}

export const stringNumberSpace = (val) => {
    const regex = /^(?=.*[a-zA-Z0-9öäüÖÄÜß])[a-zA-Z0-9öäüÖÄÜß ]*$/
    return regex.test(val)
}

export const officeNameRegex = (val) => {
    const regex = /^(?=.*[a-zA-ZöäüÖÄÜß])[a-zA-Z0-9öäüÖÄÜß #@&_.-]*$/
    return regex.test(val)
}

export const addressRegex = (val) => {
    const regex = /^(?=.*[a-zA-Z0-9öäüÖÄÜß])[a-zA-Z0-9öäüÖÄÜß\s\,\#\.\''\-]*(?!\s)*[a-z A-Z0-9öäüÖÄÜß].*$/
    return regex.test(val)
}

export const stringValidation = (val) => {
    const regex = /^[a-zA-Z0-9öäüÖÄÜß_.-]*$/;
    return regex.test(val);
};

export const onlyAlphabeticStringValidation = (val) => {
    const regex = /^[A-Za-zöäüÖÄÜß]+$/;
    return regex.test(val);
};

export const emailValidation = (email) => {
    const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email.toLowerCase());
};

export const phoneValidation = (phone) => {
    const regex =
        /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$/gm;
    return regex.test(phone.toLowerCase());
};

export const passwordValidation = (password) => {
    // const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
    const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,16}$/;
    return regex.test(password);
};

export const spaceBetweenWords = (word) =>
    word.replace(/([a-z])([A-Z])/g, "$1 $2");

export const number = (value) => {
    const regex = /^(?=.*\d)[\d,.]+$/
    return regex.test(value);
};

export const numberOnly = (value) => {
    const regex = /^\d+$/
    return regex.test(value);
};

export const maxNumbers = (value) => {
    const regex = /^[\d.,]{1,9}$/
    return regex.test(value);
}

export const floatFromString = (value) => {
    const regex = /[+-]?\d+(\.\d+)?/g;
    return value.match(regex).map(function f(v) {
        return parseFloat(v);
    });
};

//capital every words firstletter
export const firstLetterToUppercase = (value) => {
    if (value) {
        return spaceBetweenWords(value.replace(/\b\w/g, (c) => c.toUpperCase()));
    }
}
//capital only firtletter of whole word
export const capitalFirstLetter = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1)
}

export const phoneNumberValidation = (value) => {
    const regex = /^([+]\d{2})?\d{10}$/;
    return regex.test(value);
}

export const zipCodeValidation = (value) => {
    // const regex = /^0\d{4}$/;
    const regex = /^\d{5}$/;
    return regex.test(value);
}

export const specialCharacters = (value) =>
    /[-!$%^&*()_+|~=`{}[\]:/;<>?,.@#]/.test(value);

export const formatFieldName = (value) => {
    return value
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Convert camelCase to space-separated
        .replace(/_/g, ' ') // Convert snake_case to spaces
        .replace(/^\w/, (c) => c.toUpperCase()) // Capitalize the first letter
        .replace(/\b\w/g, char => char.toUpperCase())
}

export const AllLettersUpercase = (value) => {
    if (value) {
        return value.toUpperCase()
    }
}

export const truncateText = (text, length) => {
    if (text && length) {
        return text.length > length ? text.substring(0, length) + '...' : text;
    }
};

export const truncateTextAndTooltip = (id, text, length) => {
    if (text && length) {
        return (
            <div>
                {text.length > length ? text.substring(0, length) + '...' : text}
            </div>
        );
    }
};

export const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0;
}

export const isValidDate = (value) => {
  // Check if the value is a valid date string in the format MM/DD/YYYY
  const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
  if (!dateRegex.test(value)) {
    return false;
  }

  // Parse the date in MM/DD/YYYY format
  const [month, day, year] = value.split("/");
  const date = new Date(`${year}-${month}-${day}`);

  // Check if the parsed date is valid
  return !isNaN(date.getTime());
};

export const isPastDate = (value) => {
  const date = new Date(value);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to compare only the date part
  return date < today;
};



export const validateSocialMediaLink = (url, type) => {
    const patterns = {
        x: /^https:\/\/(www\.)?(twitter\.com|x\.com)\/[a-zA-Z0-9_]+\/?$/,
        Instagram: /^https:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9._%+-]+\/?$/,
        Facebook: /^https:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9.]+\/?$/,
        Tiktok: /^https:\/\/(www\.)?tiktok\.com\/@[a-zA-Z0-9._-]+\/?$/,
        Spotify: /^https:\/\/open\.spotify\.com\/(user|artist|track|album|playlist)\/[a-zA-Z0-9._-]+(\?[\S]+)?\/?$/,
        appleMusic: /^https:\/\/music\.apple\.com\/[a-zA-Z0-9._-]+\/?$/,
        Youtube: /^https:\/\/(www\.)?youtube\.com\/c\/[a-zA-Z0-9._-]+\/?$/,
        soundcloud: /^https:\/\/soundcloud\.com\/[a-zA-Z0-9._-]+\/?$/,
    };

    if (patterns[type]) {
        return patterns[type].test(url);
    }
    return false;
}